export default __webpack_public_path__ + "static/media/3M-Logo.26c635e9.png";